import React, { useEffect, useState } from 'react';
import { get } from 'lodash';
import { Route, Switch, useHistory, useRouteMatch } from 'react-router-dom';

import { refreshReloadPrompt } from 'hooks';
import PageTemplate from 'components/general/PageTemplate';
import { getSchedulers } from 'api/scheduler';
import { showOrganization } from 'api/organization';
import Scheduler from './Scheduler';
import {
  columns,
  suggestionPrimaryKey,
  suggestionSecondaryKeys,
} from './scheduler.config';

const Schedulers = () => {
  const { path } = useRouteMatch();
  const history = useHistory();

  const [modalOpen, setModalOpen] = useState(true);
  const [schedulers, setSchedulers] = useState();
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [loading, setLoading] = useState(false);
  const [blockRouteChange, setBlockRouteChange] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  const fetchSchedulers = async () => {
    const { data } = await getSchedulers(pageNumber, pageSize);

    const amendedSchedulers = data.data;

    await Promise.all(
      amendedSchedulers.map(async ({ organization_id: orgId }, index) => {
        const { data: orgData } = await showOrganization(orgId);
        amendedSchedulers[index].organizationName = orgData.data.name;
      }),
    );

    setSchedulers(amendedSchedulers);
    setRowCount(data.pagination.total);
  };

  useEffect(async () => {
    setLoading(true);

    await fetchSchedulers();
    setLoading(false);
  }, [pageNumber, pageSize]);

  const handleModalOpen = ({ id }) => {
    history.push(`/schedulers/${id}`);
    setModalOpen(true);
  };

  const handleAdd = () => {
    history.push('/schedulers/add');
    setModalOpen(true);
    fetchSchedulers();
  };

  const handleModalClose = (save) => {
    if (save && typeof save === 'boolean') {
      history.block(() => true);
      setModalOpen(false);
    }

    if (!blockRouteChange && !save && typeof save !== 'boolean') {
      setModalOpen(false);
    }

    history.push('/schedulers');
    fetchSchedulers();
    window.removeEventListener('beforeunload', refreshReloadPrompt);
  };

  return (
    <>
      <PageTemplate
        data={schedulers || []}
        columns={columns}
        suggestionPrimaryKey={suggestionPrimaryKey}
        suggestionSecondaryKeys={suggestionSecondaryKeys}
        handleModalOpen={handleModalOpen}
        setPageNumber={setPageNumber}
        setPageSize={setPageSize}
        rowCount={rowCount}
        pageNumber={pageNumber}
        pageSize={pageSize}
        loading={loading}
        handleAdd={handleAdd}
        setModalOpen={setModalOpen}
      />

      <Switch>
        <Route path={`${path}/add`}>
          <Scheduler
            modalOpen={modalOpen}
            handleModalClose={handleModalClose}
            blockRouteChange={blockRouteChange}
            setBlockRouteChange={setBlockRouteChange}
          />
        </Route>

        <Route path={`${path}/:id`}>
          <Scheduler
            modalOpen={modalOpen}
            handleModalClose={handleModalClose}
            blockRouteChange={blockRouteChange}
            setBlockRouteChange={setBlockRouteChange}
          />
        </Route>
      </Switch>
    </>
  );
};
export default Schedulers;
